import Marquee from "react-fast-marquee";

const items = [
  "Horticulture",
  "Commercial Cleaning",
  "Hygiene Management",
  "Grounds Maintenance",
  "Janitorial Supplies",
  "Facility Support",
  "Sustainability",
];

export const EditorialMarquee = () => (
  <section data-testid="editorial-marquee" className="bg-sml-forest py-10 lg:py-14 overflow-hidden">
    <Marquee speed={40} gradient={false} autoFill>
      {items.map((t, i) => (
        <div key={i} className="flex items-center">
          <span className="font-display text-4xl md:text-6xl lg:text-7xl text-white/90 px-8 tracking-tight">
            {t}
          </span>
          <span className="text-sml-bronze text-3xl md:text-5xl">✳</span>
        </div>
      ))}
    </Marquee>
  </section>
);
